import { render, staticRenderFns } from "./podcast-view.vue?vue&type=template&id=bef0e9f4&scoped=true&"
import script from "./podcast-view.vue?vue&type=script&lang=js&"
export * from "./podcast-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef0e9f4",
  null
  
)

export default component.exports